import React, { memo } from 'react'
import { CancelIcon, SuccessIcon } from 'transfix-icons'

interface IActiveStatus {
  disabled: boolean | undefined
}

export const ActiveStatus = memo<IActiveStatus>(({ disabled }) => {
  return disabled ? (
    <CancelIcon size='xlarge' color='error1' />
  ) : (
    <SuccessIcon size='xlarge' color='green2' />
  )
})
